export const { log } = console;
